export default {
    'Login.title':'Weclcome to Slides Orator',
    'Login.phoneText': 'Phone Number',
    'Login.captcha':'Sign In/Sign Up',
    'Login.getCode':'Send Code',
    'Login.resCode':'Resend',
    'Login.captchaPlaceholder':'Verification Code',
    'Login.phonePlaceholder':'Please enter your phone number', 
    'Login.phoneError':'Incorrect phone number input',
    'Login.codeError':'Please enter a 6-digit verification code',
    'Login.succeeded':'Login succeeded',
    'Login.sentCodeSucceeded':'Verification code sent successfully'
    
};